import {
  IContactRepository,
  PaginatedContactMessagesResult,
  ContactMessageDetailResult,
} from '../../../domain/repositories/contact.repository.interface';
import { ContactMessage, ContactMessageStatusType } from '../../../domain/entities/contact-message.entity';
import { ContactEmailDelivery } from '../../../domain/entities/contact-email-delivery.entity';
import { ContactMessageFiltersDTO } from '../../dtos/contact/contact-message.dto';

export class GetContactMessagesUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(filters?: ContactMessageFiltersDTO): Promise<PaginatedContactMessagesResult> {
    return this.repository.getMessages(filters);
  }
}

export class GetContactMessageByIdUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string): Promise<ContactMessageDetailResult> {
    return this.repository.getMessageById(id);
  }
}

export class UpdateContactMessageStatusUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string, status: ContactMessageStatusType): Promise<ContactMessage> {
    return this.repository.updateMessageStatus(id, status);
  }
}

export class AssignContactMessageUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string, assignedToUserId: string | null): Promise<ContactMessage> {
    return this.repository.assignMessage(id, assignedToUserId);
  }
}

export class ArchiveContactMessageUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string): Promise<ContactMessage> {
    return this.repository.archiveMessage(id);
  }
}

export class DeleteContactMessageUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(id: string): Promise<void> {
    return this.repository.deleteMessage(id);
  }
}

export class RetryContactEmailUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(messageId: string): Promise<ContactEmailDelivery[]> {
    return this.repository.retryEmail(messageId);
  }
}
